import React from 'react';
import { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ServerDay from 'src/components/calendar/dateCalendar/ServerDay';
import CalendarHeader from 'src/components/calendar/dateCalendar/CalendarHeader';
import DayOfWeekFormatter from 'src/components/calendar//dateCalendar/DayOfWeekFormatter';

type DropDownProps = {
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  error?: boolean;
};

const DatePickerCustom: React.FC<DropDownProps> = (props) => {

  const getBgColor = (defaultColor: string) => {
    return props.error ? '#d32f2f !important' : defaultColor;
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        format='YYYY/MM/DD'
        value={props.value}
        onChange={(newValue) => props.onChange(newValue)}
        dayOfWeekFormatter={DayOfWeekFormatter}
        slots={{
          // openPickerButton: IconDropDown
          day: ServerDay,
          calendarHeader: CalendarHeader
        }}
        slotProps={{
          day: {
            fullDate: true,
            sx: {
              maxWidth: '52px',
              maxHeight: '54px',
              '& .MuiButtonBase-root': { maxWidth: '52px', maxHeight: '54px' },
              mt: '0px'
            }
          } as any,
          textField: {
            sx: {
              '& .MuiOutlinedInput-root': {
                height: '48px',
                width: '160px',
                '& .MuiInputBase-input': {
                  height: '48px',
                  padding: '0 12px',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '14.4px',
                  color: 'primary.dark',
                  display: 'flex',
                  alignItems: 'center',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: getBgColor('#BDBDBD !important'),
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: getBgColor('#212121 !important'),
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: getBgColor('#23B7E5 !important'),
                },
                '& .Mui-error .MuiOutlinedInput-notchedOutline': {
                  borderColor: getBgColor('blue !important'),
                }
              },
            },
          },
          popper: {
            sx: {
              '& .Mui-selected': {
                '&:hover': {
                  backgroundColor: '#23B7E5',
                },

              },
              '& .MuiPickersDay-root.Mui-selected:focus': {
                backgroundColor: '#23B7E5',
              }
            }
          },
          inputAdornment: {
            sx: {
              '& .MuiIconButton-root': {
                color: '#A3AED0'
              }
            }
          }
        }}
        sx={{
          backgroundColor: 'primary.light',
        }}
      />
    </LocalizationProvider>
  );
}

export default DatePickerCustom;
